import { Link, NavLink } from "react-router-dom";
import { Activity, Banknote, BookOpenCheck, CalendarRange, FileWarning, LayoutGrid, LogOut, Settings, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = ({ children }) => {
  const { logout, isAdmin, user } = useAuth();
  const links = [{ to: "/", l: "Books", I: LayoutGrid, t: "nav-books" }, { to: "/summary", l: "Monthly", I: CalendarRange, t: "nav-monthly" },
    { to: "/cashouts", l: "Cashouts", I: Banknote, t: "nav-cashouts" },
    { to: "/reasons", l: "Reasons", I: FileWarning, t: "nav-reasons" },
    ...(isAdmin ? [{ to: "/activity", l: "Activity", I: Activity, t: "nav-activity" }, { to: "/staff", l: "Staff", I: Users, t: "nav-staff" }] : []), { to: "/settings", l: "Settings", I: Settings, t: "nav-settings" }];
  return (
    <header className="sticky top-0 z-40 bg-[#f6f5f0]/85 backdrop-blur-md border-b border-slate-300/70">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 h-14 flex items-center gap-3">
        <Link to="/" data-testid="header-home-link" className="flex items-center gap-2 shrink-0">
          <span className="h-8 w-8 bg-slate-900 text-yellow-300 grid place-items-center"><BookOpenCheck size={16} /></span>
          <span className="hidden xl:block text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-600">Balance Book</span>
        </Link>
        <div className="flex-1 min-w-0 flex items-center gap-2">{children}</div>
        <nav className="flex items-center shrink-0">
          {links.map(({ to, l, I, t }) => (
            <NavLink key={to} to={to} end data-testid={t} title={l}
              className={({ isActive }) => `h-9 px-2 lg:px-2.5 flex items-center gap-1.5 text-xs font-semibold transition-colors ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-200"}`}>
              <I size={15} /><span className="hidden lg:inline">{l}</span>
            </NavLink>
          ))}
        </nav>
        {user && !isAdmin && <span data-testid="staff-badge" className="hidden md:inline text-[10px] font-bold uppercase tracking-[0.12em] bg-sky-100 text-sky-900 px-2 py-1">Staff · {user.name}</span>}
        <button data-testid="logout-btn" onClick={logout} title="Log out"
          className="h-9 w-9 grid place-items-center text-slate-600 hover:bg-slate-900 hover:text-white transition-colors">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
};
